import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import { AsyncReduxState } from '../../types';

export type JobExperienceState = AsyncReduxState<{
    createIsSuccessful: boolean;
    updateIsSuccessful: boolean;
    deleteIsSuccessful: boolean;
}>;

const initialState: JobExperienceState = {
    ...initialAsyncReduxState,
    createIsSuccessful: false,
    updateIsSuccessful: false,
    deleteIsSuccessful: false,
};

export const jobExperienceSlice = createSlice({
    name: 'jobExperienceReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): JobExperienceState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setCreateIsSuccessful(state, action: PayloadAction<boolean>): JobExperienceState {
            return {
                ...state,
                createIsSuccessful: action.payload,
            };
        },
        setUpdateIsSuccessful(state, action: PayloadAction<boolean>): JobExperienceState {
            return {
                ...state,
                updateIsSuccessful: action.payload,
            };
        },
        setDeleteIsSuccessful(state, action: PayloadAction<boolean>): JobExperienceState {
            return {
                ...state,
                deleteIsSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): JobExperienceState {
            return {
                ...state,
                error: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setCreateIsSuccessful,
    setUpdateIsSuccessful,
    setDeleteIsSuccessful,
    setError,
} = jobExperienceSlice.actions;

export default jobExperienceSlice.reducer;
